"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var StatusBadge_1 = __importDefault(require("atomicComponents/molecules/Badge/StatusBadge"));
var constants_1 = require("../../constants");
var utils_1 = require("../utils");
var MatchLevel = function (_a) {
    var item = _a.item;
    return (0, jsx_runtime_1.jsx)(StatusBadge_1.default, { mapper: constants_1.MATCH_LEVEL_MAPPER, status: (0, utils_1.getMatchLevel)(item) });
};
exports.default = MatchLevel;
